/*=========================================================================================
  File Name: moduleCategoryMutations.js
  Description: Category Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	ADD_OPTIMIZATION_GROUP(state, item) {
		state.optimizationGroupList.unshift(item);
	},
	SET_OPTIMIZATION_GROUP(state, items) {
		state.optimizationGroupList = [...items];
	},
	UPDATE_OPTIMIZATION_GROUP(state, visitPoint) {
		const visitPointIndex = state.optimizationGroupList.findIndex((p) => p.id === visitPoint.id);
		if (visitPointIndex !== -1) {
			Object.assign(state.optimizationGroupList[visitPointIndex], visitPoint);
		}
	},
	REMOVE_OPTIMIZATION_GROUP(state, itemId) {
		const ItemIndex = state.optimizationGroupList.findIndex((p) => p.id === itemId);
		state.optimizationGroupList.splice(ItemIndex, 1);
	},
	SET_OPTIMIZATION_GROUP_EDIT(state, items) {
		state.optimizationGroupEditList = items;
	},
	SET_OPTIMIZATION_GROUP_SIDEBAR_ACTIVE(state, items) {
		state.isSidebarActiveEdit = items;
	},
};
